import store from '@/store';
import Vue from 'vue';
import Router from 'vue-router';
import { MUTATE_SHOW_VERIFY_EMAIL } from './store/modules/interface';

Vue.use(Router);

function requireAuth(to: any, from: any, next: any) {
    if (store.getters.isLogin) {
        next();
    } else {
        next('/signin');
    }
}

function notRequireAuth(to: any, from: any, next: any) {
    if (store.getters.isLogin) {
        next('/');
    } else {
        next();
    }
}

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            component: () => import('@/views/home/Home.vue'),
            beforeEnter: requireAuth,
            children: [
                {
                    path: '',
                    name: 'dashboard',
                    component: () => import('@/views/home/children/dashboard/Dashboard.vue'),
                    children: [
                        // {
                        //     path: 'analytics',
                        //     name: 'analytics',
                        //     component: () => import('@/views/home/children/dashboard/children/Analytics.vue'),
                        // },
                        {
                            path: 'add-product',
                            name: 'add-product',
                            beforeEnter: (to, from, next) => {
                                if (store.getters.getAuth.user.confirmed) {
                                    next();
                                    return;
                                }
                                store.commit(MUTATE_SHOW_VERIFY_EMAIL, true);
                            },
                            component: () => import('@/views/home/children/dashboard/children/AddProduct.vue'),
                        },
                        {
                            path: 'upload-csv',
                            name: 'upload-csv',
                            beforeEnter: (to, from, next) => {
                                if (store.getters.getAuth.user.confirmed) {
                                    next();
                                    return;
                                }
                                store.commit(MUTATE_SHOW_VERIFY_EMAIL, true);
                            },
                            component: () => import('@/views/home/children/dashboard/children/UploadCsv.vue'),
                        },
                        // {
                        //     path: 'track-and-trace',
                        //     name: 'track-and-trace',
                        //     component: () => import('@/views/home/children/dashboard/children/TrackAndTrace.vue'),
                        // },
                        // {
                        //     path: 'more',
                        //     name: 'more',
                        //     component: () => import('@/views/home/children/dashboard/children/More.vue'),
                        // },
                        {
                            path: '',
                            beforeEnter: (to: any, from: any, next: any) => {
                                next({ name: 'add-product' });
                            },
                        },
                    ],
                },
                {
                    path: 'products',
                    component: () => import('@/views/home/children/product/Product.vue'),
                    children: [
                        {
                            path: 'all-products',
                            name: 'all-products',
                            component: () => import('@/views/home/children/product/children/AllProducts.vue'),
                        },
                        {
                            path: 'unclaimed',
                            name: 'unclaimed-products',
                            component: () => import('@/views/home/children/product/children/UnclaimedProducts.vue'),
                        },
                        {
                            path: 'claimed',
                            name: 'claimed-products',
                            component: () => import('@/views/home/children/product/children/ClaimedProducts.vue'),
                        },
                        {
                            path: 'transferred',
                            name: 'transferred-products',
                            component: () => import('@/views/home/children/product/children/TransferredProducts.vue'),
                        },
                        {
                            path: 'all-products/:id',
                            name: 'all-products-id',
                            component: () => import('@/views/home/children/product/children/AllProducts.vue'),
                        },
                        {
                            path: '',
                            beforeEnter: (to: any, from: any, next: any) => {
                                next({ name: 'all-products' });
                            },
                        },
                    ],
                },
                // {
                //     path: 'my-order',
                //     component: () => import('@/views/home/children/my-order/MyOrder.vue'),
                //     children: [
                //         {
                //             path: 'order-list',
                //             name: 'order-list',
                //             component: () => import('@/views/home/children/my-order/children/OrderList.vue'),
                //         },
                //         {
                //             path: '',
                //             beforeEnter: (to: any, from: any, next: any) => {
                //                 next({ name: 'order-list' });
                //             },
                //         },
                //     ],
                // },
                // {
                //     path: 'settings',
                //     component: () => import('@/views/home/children/settings/Settings.vue'),
                //     children: [
                //         {
                //             path: 'profile',
                //             name: 'profile-settings',
                //             component: () => import('@/views/home/children/settings/children/ProfileSettings.vue'),
                //         },
                //         {
                //             path: 'security',
                //             name: 'security',
                //             component: () => import('@/views/home/children/settings/children/Security.vue'),
                //         },
                //         {
                //             path: 'wallet',
                //             name: 'wallet',
                //             component: () => import('@/views/home/children/settings/children/Wallet.vue'),
                //         },
                //         {
                //             path: '',
                //             beforeEnter: (to: any, from: any, next: any) => {
                //                 next({ name: 'profile-settings' });
                //             },
                //         },
                //     ],
                // },
                {
                    path: 'faq',
                    name: 'faq',
                    component: () => import('@/views/home/children/FAQ.vue'),
                },
            ],
        },
        {
            path: '/signin',
            name: 'signin',
            beforeEnter: notRequireAuth,
            component: () => import('@/views/Login.vue'),
        },
        {
            path: '/signup',
            name: 'signup',
            beforeEnter: notRequireAuth,
            component: () => import('@/views/Signup.vue'),
        },
        {
            path: '/email-confirmation',
            name: 'email-confirmation',
            beforeEnter: notRequireAuth,
            component: () => import('@/views/EmailConfirmation.vue'),
        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            beforeEnter: notRequireAuth,
            component: () => import('@/views/ForgotPassword.vue'),
        },
        {
            path: '/reset-password/:code',
            name: 'reset-password-code',
            component: () => import('@/views/ResetPassword.vue'),
        },
        {
            path: '/reset-password/',
            name: 'reset-password',
            component: () => import('@/views/ResetPassword.vue'),
        },
        {
            path: '/connect/google/callback',
            name: 'google-callback',
            component: () => import('@/views/connect/google/GoogleCallback.vue'),
        },
        {
            path: '*',
            name: 'page-not-found',
            component: () => import('@/views/PageNotFound.vue'),
        },
    ],
});
